<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="devices"
      :class="{
        opened: opened.indexOf('editTags') >= 0,
        'last-active': opened.indexOf('editTags') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleTagsConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="editTag()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("odebratTagOd") }} {{ devices.length }}
          <span v-if="devices.length > 1">{{ $t("zarizenim") }}</span>
          <span v-else>{{ $t("zarizeni") }}</span>
        </h2>
      </div>
      <div class="side-box__content">
        <FormSelectMultiple
          :items="
            tags.map((tag) => {
              return { text: tag }
            })
          "
          :label="$t('odebratTagy')"
          :placeholder="$t('vyberteTagZeSeznamu')"
          :value="selectedTags"
          class="mx-auto mt-3"
          item-text="text"
          item-value="text"
          side-box
          @change="selectedTags = $event"
        />
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedTagsConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleTagsConfirmation"
      @no="closeBox()"
      @yes="editTag()"
    />
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"

export default {
  components: {
    FormSelectMultiple,
    SaveConfirmationModal
  },
  props: {
    opened: Array,
    devices: Array,
    technology: {
      type: String,
      default: "lora"
    }
  },
  emits: ["openBox", "closeBox"],
  data() {
    return {
      tags: [],
      tagsOpened: false,
      selectedTags: [],
      writtenTags: "",
      openedTagsConfirmation: false
    }
  },
  watch: {
    opened() {
      if (!this.opened.indexOf("editTags")) {
        this.devices.forEach((device) => {
          device.tags.forEach((tag) => {
            if (!this.tags.includes(tag)) {
              this.tags = this.tags.concat([tag])
            }
          })
        })
      }
    }
  },
  mounted() {},
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === undefined) {
        this.resetValues()

        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    setProject() {},
    resetValues() {
      this.writtenTags = ""
      this.selectedTags = []
    },
    addRemoveTag(tag) {
      if (this.selectedTags.indexOf(tag) > -1) {
        this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    editTag() {
      let counter1 = 0

      this.devices.forEach((device) => {
        let tags = device.tags

        counter1++
        let counter = 0
        this.selectedTags.forEach((tag) => {
          if (tags.indexOf(tag.text) > -1) {
            let index = tags.indexOf(tag.text)
            tags.splice(index, 1)
          }
          counter++
          if (counter === this.selectedTags.length) {
            axios
              .put(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId + "/tags", tags, {})
              .then(() => {
                if (this.device) {
                  this.device.tags = tags
                }
                if (counter1 === this.devices.length) {
                  this.closeBox()
                }
              })
              .catch(() => {})
          }
        })
      })
    },
    toggleTagsConfirmation() {
      this.openedTagsConfirmation = !this.openedTagsConfirmation
    }
  }
}
</script>

<style lang="scss" scoped></style>
